import { FC } from "react"
import classNames from "classnames"
import CellStatusIcon from "./CellStatusIcon"
import { useCellCardState } from "./useCellCardState"
import { CellCardProps } from "."
import Badge from "@/components/shared/Badge"
import { Icon } from "@/components/shared/Icon"
import { TestId } from "@/constants/globals"
import { getCellIconName, getCellIconTestId } from "@/utils/cells"
import "./index.scss"

interface CellCardSmallProps extends CellCardProps {
   showCellIcon?: boolean
   hasAction?: boolean
   isClickable?: boolean
}

const CellCardSmall: FC<CellCardSmallProps> = ({
   occupied,
   maintenance,
   isCustom,
   hasDoorSensor = false,
   doorSensorLowBattery = false,
   cellStatus: cell,
   userStatus,
   typefaceColor,
   showCellIcon = false,
   hasAction = false,
   isClickable = false,
   isCollapsed,
   onClick,
}) => {
   const {
      cellStatus,
      typefaceClassName,
      typefaceIconColor,
      isMoving,
      humanPresenceInVacant,
   } = useCellCardState({
      cellStatus: cell,
      occupied,
      maintenance,
      typefaceColor,
      userStatus,
   })

   const iconName = getCellIconName(
      isCustom,
      hasDoorSensor,
      doorSensorLowBattery
   )

   return (
      <Badge invisible={!hasAction}>
         <div
            data-testid={TestId.CELL_CARD}
            className={classNames(
               "cell-card",
               "cell-card--small",
               `cell-card--${cellStatus}`,
               typefaceClassName,
               {
                  "cell-card--clickable": isClickable,
                  "cell-card--collapsed": isCollapsed,
                  "cell-card--custom": isCustom,
               }
            )}
            onClick={onClick}
         >
            {showCellIcon ? (
               <Icon
                  className={classNames({
                     "cell-card__door-sensor-battery-icon":
                        doorSensorLowBattery,
                  })}
                  size="16"
                  color={typefaceIconColor}
                  name={iconName}
                  data-testid={getCellIconTestId(iconName)}
               />
            ) : (
               <CellStatusIcon
                  size="16"
                  typeface={typefaceIconColor}
                  cellStatus={cellStatus}
                  isMoving={isMoving}
                  humanPresenceInVacant={humanPresenceInVacant}
               />
            )}
         </div>
      </Badge>
   )
}

export default CellCardSmall
